module.exports = __webpack_public_path__ + "static/media/upiNotification.b80e37ba.svg";